module.exports = __webpack_public_path__ + "img/training.5baaff82.svg";